<template lang="pug">
  .padding
    h5._300.margin Settlement

    .box
      v-server-table(
        ref="datatable"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options"
      )
        template(slot="download" slot-scope="props")
          a(@click='downloadFile(props.row.download_url)')
            i.fa.fa-fw.fa-cloud-download

</template>

<script>
const TableName = 'VUETABLE_SETTLEMENT';

export default {
    data() {
        return {
            outlet: null,
            tableName: TableName,
            api: Laroute.route('franchise.report.settlement.table'),
            columns: ['mid', 'timestamp', 'path', 'download'],
            options: {
                orderBy: { column: 'name', ascending: 1 },
                headings: {
                    mid: 'Merchant ID',
                    timestamp: 'Date',
                    path: 'Settlement Name',
                },
            },
        };
    },
    methods: {
        downloadFile(url) {
            window.location.href = url;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/settlement/vuetable_settlement.vue